export default class NumericInterval {
  constructor(
    public min: number | null = null,
    public max: number | null = null,
  ) {}

  isValid(): boolean {
    if (!this.isBothEndsBounded()) {
      return true;
    }

    return typeof this.min === "number" && typeof this.max === "number"
      ? this.min <= this.max
      : true;
  }

  isLeftBounded(): boolean {
    return typeof this.min === "number" && Number.isFinite(this.min);
  }

  isRightBounded(): boolean {
    return typeof this.max === "number" && Number.isFinite(this.max);
  }

  isBothEndsBounded(): boolean {
    return this.isLeftBounded() && this.isRightBounded();
  }

  isBothEndsUnbounded(): boolean {
    return !this.isLeftBounded() && !this.isRightBounded();
  }
}
